import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import { observer, inject } from "mobx-react";
import LoginForm from "../auth/LoginForm";
import Link from '@/components/common/Link';

const Login = inject('studioStore')(observer(({ studioStore }) => {
  const router = useRouter();
  const ta = useTranslations('Auth');
  const t = useTranslations('Account');
  const container = studioStore.settings.login_register?.container;
  const containerBackgroundColor = studioStore.settings.login_register?.container_background_color;

  let classes = "login-register-content max-w-lg mx-auto px-6 py-7 overflow-hidden mt-8";
  const style = {
    backgroundColor: containerBackgroundColor,
  };

  if (container === "stamp") {
    classes = classes + " stamp-border";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${containerBackgroundColor}),linear-gradient(${containerBackgroundColor} 0px, ${containerBackgroundColor} 0px)`;
    style.backgroundColor = '';
  }

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const redirectUrl = localStorage.getItem('redirectUrl');
      localStorage.removeItem('redirectUrl');
      router.push(redirectUrl || '/');
    }
  }, [router]);

  const handleLoginSuccess = () => {
    const redirectUrl = localStorage.getItem('redirectUrl');
    localStorage.removeItem('redirectUrl');
    router.push(redirectUrl || '/');
  };

  return (
    <div className={`${classes}`} style={style}>
      <div className="content p-5">
        <h2 className="text-2xl font-bold text-primary-studio font-secondary mb-3">
          {t('login')}
        </h2>
        <p className="text-gray-600 mb-6 text-sm">{t('welcome_back')}</p>
        <LoginForm onSuccess={handleLoginSuccess} />
        <div className="flex flex-col gap-2 pt-5">
          <div className="flex gap-2">
            <p className="text-gray-600 text-sm">{t('dont_have_account')}</p>
            <Link className="text-gray-600 text-sm underline" href="/register" data-testid="register-link">
              {t('register_here')}
            </Link>
          </div>
          <div className="flex gap-2">
            <Link className="text-gray-600 text-sm underline" href="/reset-password/request">
              {ta('forgot_password')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}));

export default Login;
